import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { aboutPageImage, warehouseImage } from '../mock';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function About() {
  return (
    <>
      <Navbar />
      <section style={{ paddingTop: 180, paddingBottom: 80, background: 'var(--sm-ivory)' }}>
        <div className="container-x">
          <Link to="/" className="link-underline" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 12, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'var(--sm-navy)', textDecoration: 'none', marginBottom: 40 }}>
            <ArrowLeft size={14} /> Back Home
          </Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
            <span className="hairline" />
            <span className="overline">Company Overview</span>
          </div>
          <h1 className="serif" style={{ fontSize: 'clamp(44px, 6vw, 84px)', lineHeight: 1.02, letterSpacing: '-0.02em', margin: 0, maxWidth: 900, color: 'var(--sm-navy)' }}>
            The story of ES Investments <span style={{ color: 'var(--sm-gold)' }}>Management LLC</span>.
          </h1>
        </div>
      </section>

      <section style={{ paddingBottom: 96, background: 'var(--sm-ivory)' }}>
        <div className="container-x">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 80 }} className="about-page-grid">
            <div style={{ aspectRatio: '3/4', overflow: 'hidden', position: 'sticky', top: 120, alignSelf: 'start' }}>
              <img src={aboutPageImage} alt="Global operations" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div style={{ fontSize: 17, lineHeight: 1.9, color: 'var(--sm-navy)', textAlign: 'justify' }}>
              <p style={{ marginTop: 0 }}><strong>ES Investments Management LLC</strong> is a New York-based company recognized for its impact in the global apparel and off-price distribution industry. The company was built on vision, execution, and an instinct for opportunity. These are the driving forces behind a platform that connects international supply with large-scale retail demand.</p>
              <p>Our foundation lies in more than two decades of sourcing from Asia, mastering apparel supply chains, and building trusted relationships with manufacturing networks worldwide. That expertise informs every corner of the business today: from vendor negotiations to logistics coordination to counterparty management at scale.</p>
              <p>As our understanding of the industry deepened, we identified an opportunity in the off-price market, where brand-name clothing, footwear, and accessories reach consumers at significant discounts. We recognized inefficiencies around excess inventory and retail demand and built a scalable model to serve them: sourcing branded closeout merchandise and redistributing it through established off-price retail channels.</p>
              <div style={{ margin: '48px 0', overflow: 'hidden', aspectRatio: '16/9' }}>
                <img src={warehouseImage} alt="Distribution operations" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <p>ES Investments Management LLC has earned a reputation as a dependable, trusted, and strategic distributor, attracting some of the world&rsquo;s most recognized brands and retailers. Our clients benefit from high-quality merchandise at competitive price points, together with our ability to understand market timing and demand cycles and to execute high-volume transactions across multiple regions.</p>
              <p>Beyond distribution, the company is a committed <strong>real estate investor</strong>. We channel the discipline of two decades of trade into long-horizon property investments, prioritizing quality locations, resilient income, and patient capital.</p>
              <p>Headquartered in New York City, with processing and logistics capabilities across California and Florida, ES Investments Management LLC remains actively engaged with philanthropy and community initiatives, believing that small, consistent contributions create meaningful long-term change.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        @media (max-width: 900px) {
          .about-page-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
          .about-page-grid > div:first-child { position: static !important; }
        }
      `}</style>
    </>
  );
}
